class RegionController {
  constructor() {
    this.name = 'region';
  }
}

export default RegionController;



// WEBPACK FOOTER //
// ./client/app/components/region/region.controller.js